import {SelectionModel} from '@angular/cdk/collections';
import {SelectionStatus} from './selection-status';

export type SelectionType = 'single' | 'multi' | 'none';

export type AssignmentSelectionType = 'single' | 'multi';

export type SelectionDisableFn = (selection?: SelectionModel<any>) => false | string;

export type PredicateFn = (item: any) => boolean;

export class MxSelection {

    static selectionStatus(selection: SelectionModel<any>): SelectionStatus {
        // SelectionStatus is used for modifying grid buttons 'disabled' status according to number of selected grid rows.
        // Related to buttons defined through buttonsTemplate only.
        if (selection.selected.length > 1) {
            return 'multi';
        } else if (selection.selected.length === 1) {
            return 'single';
        } else {
            return 'none';
        }
    }

    static noneOrMultipleSelection(selection: SelectionModel<any>,
                                   disabledRowMatchPredicateFn: PredicateFn, message: string): false | string;
    static noneOrMultipleSelection(selection: SelectionModel<any>,
                                   disabledRowMatchPredicateFn: PredicateFn[], message: string[]): false | string;
    static noneOrMultipleSelection(selection: SelectionModel<any>, disabledFn?: SelectionDisableFn, message?: false): false | string;

    static noneOrMultipleSelection(selection: SelectionModel<any>,
            disabledRowMatchPredicateFnOrDisabledFn?: PredicateFn | PredicateFn[] | SelectionDisableFn,
            message?: string | string[] | false): false | string {

        const selectionStatus = MxSelection.selectionStatus(selection);
        if (selectionStatus === 'none' || selectionStatus === 'multi') {
            return 'One and only row should be selected';
        }
        return MxSelection.handleFns(selection, disabledRowMatchPredicateFnOrDisabledFn, message);
    }

    static noneSelection(selection: SelectionModel<any>, disabledRowMatchPredicateFn: PredicateFn, message: string): false | string;
    static noneSelection(selection: SelectionModel<any>, disabledRowMatchPredicateFn: PredicateFn[], message: string[]): false | string;
    static noneSelection(selection: SelectionModel<any>, disabledFn?: SelectionDisableFn, message?: false): false | string;

    static noneSelection(selection: SelectionModel<any>,
            disabledRowMatchPredicateFnOrDisabledFn?: PredicateFn | PredicateFn[] | SelectionDisableFn,
            message?: string | string[] | false): false | string {

        const selectionStatus = MxSelection.selectionStatus(selection);
        if (selectionStatus === 'none') {
            return 'At least one row should be selected';
        }
        return MxSelection.handleFns(selection, disabledRowMatchPredicateFnOrDisabledFn, message);
    }

    private static handleFns(selection: SelectionModel<any>,
            disabledRowMatchPredicateFnOrDisabledFn?: PredicateFn | PredicateFn[] | SelectionDisableFn,
            message?: string | string[] | false): false | string {

        if (!disabledRowMatchPredicateFnOrDisabledFn) {
            return false;
        }
        if (message === undefined || message === false) {
            let disabledFn = <SelectionDisableFn>disabledRowMatchPredicateFnOrDisabledFn;
            return disabledFn(selection);
        }
        let predicateFns: PredicateFn[] = [];
        let predicateMsgs: string[];
        if (Array.isArray(disabledRowMatchPredicateFnOrDisabledFn)) {
            predicateFns = <PredicateFn[]>disabledRowMatchPredicateFnOrDisabledFn;
            predicateMsgs = <string[]>message;
        } else {
            predicateFns = [<PredicateFn>disabledRowMatchPredicateFnOrDisabledFn];
            predicateMsgs = [<string>message];
        }
        for (let i = 0; i < predicateFns.length; i++) {
            let predicateFn = predicateFns[i];
            let predicateMsg = predicateMsgs[i];
            if (MxSelection.handlePredicateFn(selection, predicateFn, predicateMsg)) {
                return predicateMsg;
            }
        }
        return false;
    }

    private static handlePredicateFn(selection: SelectionModel<any>, predicateFn: PredicateFn, message: string): false | string {
        if (selection.selected.findIndex(item => predicateFn(item)) > -1) {
            return message;
        }
        return false;
    }
}
